<script>
    import { onMount } from "svelte";
    import { visiblePage, authToken } from "../stores.js";

    onMount(() => {
        authToken.set(null);
        visiblePage.set("/sign-in/");
    });
</script>
